import React from 'react';
import { 
  AuthNavigation,
} from '@BUP/navigations';

const BraveUp = () => {  
  return (
    <div className="braveup-main-container">
      <AuthNavigation />
    </div>
  )
}

export default BraveUp;